import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import cache from '../../core/cache'
import {errorStatus} from '../../core/redux/status'
import {connectForm, selectField} from '../../core/redux/form'
import {connectWizard} from '../../core/wizard'
import extract from '../../core/extract'
import {phoneField} from '../../core/phonez'
import {relFilter} from '../../core/links'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import ButtonToggle from '../../core/components/ButtonToggle'
import PatrimonyPicker from '../../patrimony/components/PatrimonyPicker'
import {REFERENCE_USER_CMD_UPDATED, updateReferenceUserCmd, sendReferenceUserCmd, loadCompany, loadUserStream} from '../actions'
import {REFERENCE_USER_CMD_TYPES, createValidator, ReferenceUserCmd} from '../models'
import i18n from '../i18n'
import style from './ReferenceUserPopover.less'

const WIZARD_STEPS = [1]
const WIZARD_STEPS_PATRIMONY_MANAGER = [1, 2]

const schemaCache = cache()

function selectSchema(cmd, {wizard}) {
    const schema = ReferenceUserCmd.selectSchema(cmd)

    return schemaCache([schema, wizard.activeStep], () => {
        if (wizard.matchActiveStep(1) && (cmd && cmd.commandType == 'ReferencePatrimonyManager')) {
            return {
                ...schema,
                properties: {
                    firstName: schema.properties.firstName,
                    lastName: schema.properties.lastName,
                    login: schema.properties.login,
                    job: schema.properties.job,
                    phone: schema.properties.phone,
                    commandType: schema.properties.commandType
                },
                required: ['firstName', 'lastName', 'login', 'commandType']
            }
        }
        return schema
    })
}

function selectSteps({cmd}) {
    switch(cmd && cmd.commandType) {
        case 'ReferencePatrimonyManager': return WIZARD_STEPS_PATRIMONY_MANAGER
        default: return WIZARD_STEPS
    }
}

function restrict(allowed, value) {
    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0]
    return allowed[0]
}

class ReferenceUserPopover extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, cmd, company, companyUsers} = this.props

        const commandTypes = REFERENCE_USER_CMD_TYPES.filter(relFilter(companyUsers._links))
        const commandType = restrict(commandTypes, cmd && cmd.commandType)

        this.setState({commandTypes})

        dispatch(updateReferenceUserCmd({
            commandType: commandType,
            companyUid: company.uid
        }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.company != this.props.company
            || nextProps.companyUsers != this.props.companyUsers) {
            const {dispatch, cmd, company, companyUsers} = nextProps

            const commandTypes = REFERENCE_USER_CMD_TYPES.filter(relFilter(companyUsers._links))
            this.setState({commandTypes})

            dispatch(updateReferenceUserCmd({
                commandType: restrict(commandTypes, cmd && cmd.commandType),
                companyUid: company.uid
            }))
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props

        return dispatch(sendReferenceUserCmd()).then(() => {
            return Promise.all([
                dispatch(loadCompany()),
                dispatch(loadUserStream())
            ])
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, company, companyAgencies, companyUsers, wizard, onHide, ...others} = this.props
        const {commandTypes} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const commandTypeField = (field) => {
            function onChange(value) {
                if (value) {
                    field.onChange(value)
                }
            }

            return {...field, onChange}
        }

        return (
            <Popover bsClass='popover-lg popover'
                title={i18n.newUser}
                {...others}>
                {wizard.matchActiveStep(1) && (
                    <div>
                        {commandTypes.length > 1 && (
                            <div className={style.cmdType}>
                                <Row>
                                    <Col xsHidden sm={3}>
                                        <h5>type</h5>
                                    </Col>
                                    <Col sm={9}>
                                        <ButtonToggle
                                            {...commandTypeField(form.commandType())}>
                                            <ul className={style.container}>
                                                {commandTypes.map((cmdType, index) => (
                                                    <li
                                                        key={index}>
                                                        <Button
                                                            bsStyle='link'
                                                            value={cmdType}>
                                                            <Icon
                                                                icon={cmdType.slice(9)}
                                                                size='md' />
                                                            <span>{extract(i18n.referenceUserCmdTypeEnum, cmdType)}</span>
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </ButtonToggle>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        <form className='form-horizontal'>
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='firstName'
                                label={requiredLabel(i18n.firstName)}
                                {...form.firstName()} />
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='lastName'
                                label={requiredLabel(i18n.lastName)}
                                {...form.lastName()} />
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='login'
                                label={requiredLabel(i18n.login)}
                                {...form.login()} />
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='job'
                                label={i18n.job}
                                {...form.job()} />
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='phone'
                                label={i18n.phone}
                                {...phoneField(form.phone())} />
                            {form.managedAgencies && (
                                <Input multiple
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='select'
                                    name='agency'
                                    label={requiredLabel(i18n.agency)}
                                    {...selectField(form.managedAgencies(), true)}>
                                    {companyAgencies.map((agency, index) => (
                                        <option
                                            key={index}
                                            value={agency.uid}>
                                            {agency.label}
                                        </option>
                                    ))}
                                </Input>
                            )}
                        </form>
                    </div>
                )}
                {wizard.matchActiveStep(2) && (
                    <div>
                        {form.managedPatrimonies && (
                            <PatrimonyPicker multi split
                                company={company}
                                {...form.managedPatrimonies()} />
                        )}
                    </div>
                )}
                <ButtonToolbar>
                    {!wizard.hasNextStep() && (
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                    )}
                    {wizard.hasPreviousStep() && (
                        <Button
                            bsSize='large'
                            onClick={(e) => wizard.previousStep()}>
                            previous
                        </Button>
                    )}
                    {wizard.hasNextStep() && (
                        <Button
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && (wizard.nextStep() || true) || dispatch(errorStatus(i18n.formInvalid))}>
                            next
                        </Button>
                    )}
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

ReferenceUserPopover = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: selectSchema,
    action: REFERENCE_USER_CMD_UPDATED
})(ReferenceUserPopover)

ReferenceUserPopover = connectWizard({
    steps: selectSteps
})(ReferenceUserPopover)

ReferenceUserPopover = connect((state) => ({
    cmd: state.company.referenceUserCmd,
    company: state.company.company,
    companyAgencies: state.company.companyAgencies,
    companyUsers: state.company.companyUsers
}))(ReferenceUserPopover)

export default ReferenceUserPopover


// WEBPACK FOOTER //
// ./lib/company/components/ReferenceUserPopover.js